import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { env } from "cloudflare:workers";
import { getAuth } from "./auth";

/**
 * Server function to get the current session.
 * This runs on the server and has access to cookies via request headers.
 * Use this in beforeLoad hooks instead of authClient.getSession().
 */
export const getServerSession = createServerFn({ method: "GET" }).handler(
  async () => {
    const request = getRequest();
    if (!request) {
      return null;
    }

    const auth = getAuth(env);

    const session = await auth.api.getSession({
      headers: request.headers,
    });

    return session;
  },
);
